import type { SmartSort } from '@iheartjane/dm-sdk';

import { CURRENT_PAGE_QUERY_KEY } from './queryParams';

export function parseLoadedPage(searchParams: URLSearchParams): number {
  const page = Number(searchParams.get(CURRENT_PAGE_QUERY_KEY));
  return Number.isInteger(page) && page > 1 ? page : 1;
}

/**
 * Replays the pages a shopper had scrolled through on a server-side instance,
 * so the serialized payload already contains them.
 */
export async function restoreLoadedPages<ProductShape extends object>(
  instance: SmartSort<ProductShape> | undefined,
  loadedPage: number
): Promise<void> {
  for (
    let page = 1;
    instance && page < loadedPage && instance.hasNextPage();
    page += 1
  ) {
    await instance.nextPage();
  }
}

export function withoutLoadedPage(
  searchParams: URLSearchParams
): URLSearchParams {
  const params = new URLSearchParams(searchParams);
  params.delete(CURRENT_PAGE_QUERY_KEY);
  return params;
}

/**
 * Records one more product page on screen without a router navigation, so a
 * reload or back navigation can replay them server-side. Reads
 * `window.location` rather than the router, which never sees this write.
 */
export function advanceLoadedPageInUrl(): void {
  const url = new URL(window.location.href);
  const loadedPage = parseLoadedPage(url.searchParams) + 1;
  url.searchParams.set(CURRENT_PAGE_QUERY_KEY, String(loadedPage));
  window.history.replaceState(window.history.state, '', url);
}
